import loadable from '@loadable/component'
import { EVEntry, EVPage } from '@uswitch/ev-core/react'
import { useEntity } from '@uswitch/ev-utils/context/selectors'
import React from 'react'

import { usePageContext } from '~/contexts/page-context'

const MetaData = loadable(() => import('../meta-data/meta-data'))
const PostcodeCheckerHero = loadable(() => import('../hero/wrappers/postcode-checker-hero'))

const PostcodeCheckerLanding = () => {
  const { embeddedEeveeEntityIds } = usePageContext()

  const modularPage = useEntity({ id: embeddedEeveeEntityIds.modularPage })
  const { title, metaDescription } = modularPage || {}

  return (
    <>
      <MetaData metaTitle={title} metaDescription={metaDescription} />

      <PostcodeCheckerHero>
        {embeddedEeveeEntityIds.heroContent && <EVEntry id={embeddedEeveeEntityIds.heroContent} />}
      </PostcodeCheckerHero>

      <div className='us-container'>
        <div className='us-grid-row us-padding-top--small'>
          {embeddedEeveeEntityIds.modularPage && <EVPage id={embeddedEeveeEntityIds.modularPage} />}
        </div>
      </div>
    </>
  )
}

export default PostcodeCheckerLanding
